"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsEmailValidator {
    constructor(options) {
        this.options = options;
    }
    isValid(input) {
        if (input) {
            return validatorJS.isEmail(input, this.options);
        }
        return false;
    }
}
exports.IsEmailValidator = IsEmailValidator;
//# sourceMappingURL=IsEmailValidator.js.map